import { Form, Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/Provider/ProviderModel';
import { RootState } from '../../../store';
import ProviderForm from '../ProviderForm/ProviderForm';

const ProviderModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxProvider = useSelector((state: RootState) => state.models.provider);

  return (
    <Form.Provider>
      <Modal
        title={!!reduxProvider.id ? 'Modifica' : 'Adauga'}
        open={reduxProvider.props.isModalVisible}
        onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
        width={800}
        footer={false}
      >
        <ProviderForm />
      </Modal>
    </Form.Provider>
  );
};
export default ProviderModal;
